"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewInjectorChannel = void 0;
const topic_1 = require("../../topic");
const VIEW_INJECTOR_CHANNEL = 'viewInjector';
class ViewInjectorChannel {
    constructor(_logger) {
        this._logger = _logger;
        this.channel = VIEW_INJECTOR_CHANNEL;
        this.topics = {
            SetVisible: new topic_1.Topic('SetVisible', VIEW_INJECTOR_CHANNEL, this._logger),
            InjectFooterAfterInit: new topic_1.Topic('InjectFooterAfterInit', VIEW_INJECTOR_CHANNEL, this._logger),
            SetIsError: new topic_1.Topic('SetIsError', VIEW_INJECTOR_CHANNEL, this._logger),
        };
    }
}
exports.ViewInjectorChannel = ViewInjectorChannel;
//# sourceMappingURL=view-injector.channel.js.map